import { Dispatch } from 'react';
import { AddressesAction } from '../../../../details/addresses/addressesActionType';
import { connect } from 'react-redux';
import BanchiAddressLineField from './BanchiAddressLineField';
import { IReduxRootState } from '../../../reduxRootState.interface';

function mapStateToProps(state: IReduxRootState) {
    return {
        masterAddress: state.addresses.masterAddress,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AddressesAction>) {
    return {};
}

const BanchiAddressLineFieldContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(BanchiAddressLineField);

export default BanchiAddressLineFieldContainer;
